"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = exports.EmailTemplateType = void 0;
var EmailTemplateType;
(function (EmailTemplateType) {
    // must be completed
    EmailTemplateType["CUSTOMER_ORDER_CONFIRMED"] = "customer.order.confirmed";
    EmailTemplateType["CUSTOMER_ORDER_CANCELED"] = "customer.order.canceled";
    EmailTemplateType["CUSTOMER_ORDER_CANCELED_FEES"] = "customer.order.canceledFees";
    EmailTemplateType["CUSTOMER_ORDER_DONE_UNPAID"] = "customer.order.doneUnpaid";
    EmailTemplateType["CUSTOMER_ORDER_DONE_PAID"] = "customer.order.donePaid";
    EmailTemplateType["CUSTOMER_ORDER_NEW_QUOTE"] = "customer.order.newQuote";
    EmailTemplateType["CUSTOMER_ORDER_NEW_QUOTE_ACTION"] = "customer.order.newQuoteAction";
    EmailTemplateType["TRADER_WELCOME"] = "trader.welcome";
    EmailTemplateType["TRADER_INVOICE"] = "trader.invoice";
    EmailTemplateType["TRADER_JOB_DONE"] = "trader.jobDone";
    EmailTemplateType["TRADER_DOCUMENT_VALIDITY"] = "trader.documentValidity";
    EmailTemplateType["PRO_SIGNUP"] = "pro.signup";
})(EmailTemplateType = exports.EmailTemplateType || (exports.EmailTemplateType = {}));
var Status;
(function (Status) {
    Status["TO_SEND"] = "TO_SEND";
    Status["SENT"] = "SENT";
})(Status = exports.Status || (exports.Status = {}));
//# sourceMappingURL=index.js.map